import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { translate } from "application/functions";
import search from "assets/img/search.png";
import selectImg from "assets/img/select-all.png";
import { filter, contains, map, toLower, append, isEmpty, length } from "ramda";

const OptionsBox = (props) => {
  const { isMulti, options, onChange, locale, setMultiValues, multiValues, isModal } = props;

  const [inputValue, setInputValue] = useState("");

  const manageMultiValues = (option) => {
    if (contains(option, multiValues)) {
      setMultiValues(filter(value => value !== option, multiValues));
    } else {
      setMultiValues(append(option, multiValues));
    }
  }

  const getOptionRow = (option) =>{
    if (isMulti) {
      return (
        <div className="options-box__multi-option-container" key={option.value}>
          <label style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              value={option.value}
              checked={contains(option.value, multiValues)}
              onChange={() => manageMultiValues(option.value)}
            />
            <span className="options-box__checkmark"></span>
            <span className="options-box__multi-option">
              {option.label}
            </span>
          </label>
        </div>
      );
    }
    return (
      <div className="options-box__simple-option" key={option.value} onClick={() => onChange(option.value)}>
        {option.label}
      </div>
    )
  }

  const selectAll = () => {
    if (!isEmpty(multiValues)) {
      setMultiValues([]);
    } else {
      setMultiValues(map(option => option.value, options));
    }
  }

  return (
    <Fragment>
      <div className="options-box__container">
        <div className="options-box__field-container">
          <div className="options-box__field">
            <input
              className="options-box__input-field"
              type="text"
              placeholder={translate("field.search", locale)}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <img
              src={search}
              alt={translate("field.search", locale)}
              className="options-box__search-icon"
            />
          </div>
        </div>
        <div className={`options-box__options-box-container${isMulti ? "" : "--simple"}`}>
          <div className="options-box__options-box-scroll">
            {map(filteredOption => {
              return getOptionRow(filteredOption);
            }, filter(option => contains(toLower(inputValue), toLower(option.label)), options))}
          </div>
        </div>
        {isMulti &&
          <div className="options-box__multi-bottom-container">
            <div className="options-box__select-all-container">
              <div className="options-box__multi-option-container">
                <label style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    value={false}
                    checked={length(multiValues) === length(options)}
                    onChange={() => selectAll()}
                  />
                  <span className="options-box__checkmark"></span>
                  <span className="options-box__select-all">
                    {translate("field.select.all", locale)}
                  </span>
                </label>
              </div>
              <img
                src={selectImg}
                alt={translate("field.select.all", locale)}
                className="options-box__select-all-icon"
              />
            </div>
            {isModal &&
              <div className="options-box__button" onClick={() => onChange(multiValues)}>
                {translate("field.accept", locale)}
              </div>
            }
          </div>
        }
      </div>
    </Fragment>
  );
}

OptionsBox.propTypes = {
  isMulti: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  locale: PropTypes.string,
  multiValues: PropTypes.array,
  setMultiValues: PropTypes.func,
  isModal: PropTypes.bool,
}

export default OptionsBox;